import api from '.'

export interface SyncRolePermissionsPayload {
  permission_ids: number[]
}

export async function syncRolePermissions(
  id: string,
  payload: SyncRolePermissionsPayload,
): Promise<void> {
  await api.put(`/${id}/permissions`, payload)
}
